export default "__VITE_ASSET__v_BN68$x__"